export enum RightColumnWidget {
  TaskList,
  TrendingNotes,
  TrendingPeople,
  TrendingHashtags,
  LatestArticls,
  LiveStreams,
  InviteFriends,
}
